<template>
  <div class="modal-body">
    <h2 class="agre-title">Announcement on the addition of the "PrintDoors Platform User Commitment Guarantee for Image Uploads"</h2>
    <h5 class="agre-tit">Dear PrintDoors custom users:</h5>
    <p class="agre-p">
      PrintDoors platform will be launched today new terms of service to ensure better maintenance of the PrintDoors platform operation order, regulate user behavior, this platform is now officially new "PrintDoors platform user upload image commitment guarantee" terms, the user in the use of image upload function need to sign a new "refers to the PrintDoors platform user upload image Please read it carefully and choose carefully whether to continue to use the PrintDoors platform to upload images.
    </p>
    <h5 class="agre-tit mb">
      Also, we would like to remind you that on and before the effective date of this notice, please check your own exclusive gallery and order content for any content that violates the rules of the platform or infringes laws and regulations, and review your images before uploading them to see if they contain risk-sensitive information.
    </h5>
    <h5 class="agre-tit mb color-0">
      You should be aware that you are legally responsible for your actions and words, including the images and information you upload, and the consequences thereof, so please make sure you comply with the relevant laws, regulations and platform rules when using the PrintDoors Platform.
    </h5>
    <h5 class="agre-tit">"PrintDoors Platform User Pledge for Image Uploads"</h5>
    <h5 class="agre-tit">Dear user, you hereby promise and guarantee that the uploaded images and texts shall not contain the following contents:</h5>
    <p class="agre-p">(1) Oppose the basic principles established by the Constitution.</p>
    <p class="agre-p">
      (2) That endanger national security, disclose state secrets, subvert state power, undermine national unity, or damage the portraits of Chinese and national leaders, state organs, law enforcement officers or revolutionary leaders
    </p>
    <p class="agre-p">(3) Damaging national honor and interests</p>
    <p class="agre-p">
      (4) Distorting, scandalizing, desecrating, denying the deeds and spirit of heroic martyrs, insulting, slandering or otherwise infringing upon the name, portrait, reputation and honor of heroic martyrs
    </p>
    <p class="agre-p">(5) Promote terrorism, extremism or incite the implementation of terrorist activities, extremist activities</p>
    <p class="agre-p">(6) Inciting ethnic hatred, ethnic discrimination, undermining national unity</p>
    <p class="agre-p">(7) Undermine the state's religious policy, promoting cults and feudal superstition</p>
    <p class="agre-p">(8) Spreading rumors, disrupting the economic and social order</p>
    <p class="agre-p">(9) Dissemination of obscenity, pornography, gambling, violence, murder, terrorism or abetting crime</p>
    <p class="agre-p">(10) Involving sovereignty, terrorism, violence, infringement, feudalism, pornography, gambling and drugs and other illegal acts</p>
    <p class="agre-p">(11) Insulting or defaming others, infringing on the reputation, privacy, portrait or other legitimate rights and interests of others</p>
    <p class="agre-p">
      (12) Infringement of third party intellectual property rights (including but not limited to copyright, trademark rights, patent rights, privacy or portrait rights), trade secrets and other proprietary rights
    </p>
    <p class="agre-p">(13) Iinfringes the rights and interests of minors, abets crime or any other violation of public order and morality</p>
    <p class="agre-p">(14) Fraudulent, false, inaccurate or misleading</p>
    <p class="agre-p">(15) May constitute or contribute to a crime or infringement</p>
    <p class="agre-p">(16) Contains any information that discriminates against another person on the basis of race, religion, gender, sexual orientation, age, disability, ancestry or nationality</p>
    <p class="agre-p">
      (17) Publish any illegal, criminal, harassing, defamatory, abusive, threatening, injurious, vulgar, obscene, or uncivilized pictures or words.
    </p>
    <p class="agre-p">
      (18) Other content that is prohibited by law, administrative regulations, and other content that is contrary to the public interest or public morality or is inappropriate to be posted on the PrintDoors platform based on the provisions of the relevant PrintDoors platform agreements, terms, and rules.
    </p>
    <p class="agre-p">
      (19) The presence of viruses, Trojan horses, crawlers, and other malicious software or program code that may damage, tamper with, delete, or affect the normal operation of any system of the PrintDoors Platform or secretly obtain data or personal information of the PrintDoors Platform and other users without authorization.
    </p>
    <p class="agre-p">
      (20) Any other content that is contrary to the public interest or public morality or is not suitable for publication on the Platform in accordance with the provisions of the relevant PrintDoors Platform agreements and rules.
    </p>
    <h5 class="agre-tit" style="margin-top: 20px">
      The PrintDoors Platform reserves the right to <span> warn, lock, freeze</span>, or even <span>shut down your account</span> for any violation of the above agreements. If your actions are suspected of being illegal, the PrintDoors platform has the right to report them to the relevant supervisory authorities.
    </h5>
    <div style="margin-top:30px;text-align:right">
      <a-button @click="visibleBook" style="margin-right:10px">Close</a-button>
      <a-button :disabled="!!time" @click="$emit('bookSubmit')"
        >Confirm <span v-if="time">{{ time }}s</span>
      </a-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: 10
    }
  },
  props: ['visibleBook'],
  methods: {},
  mounted() {
    const timer = setInterval(() => {
      this.time--
      if (this.time === 0) {
        clearInterval(timer)
      }
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.modal-body {
  padding: 30px;
  .agre-title {
    font-size: 16px;
    color: #666;
    text-align: center;
  }
  .agre-tit {
    font-size: 14px;
    color: #666;
    &.mb {
      margin-bottom: 20px;
    }
    &.color-0 {
      color: #000;
      font-weight: bold;
    }
    span {
      color: #000;
      font-weight: bold;
    }
  }
  .agre-p {
    font-size: 14px;
    text-indent: 2em;
    margin-bottom: 8px;
    color: #666;
  }
}
</style>
